var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html as litHtml } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { html, unsafeStatic } from 'lit/static-html.js';
import {} from '@galigeo-store/galigeojs';
let NodeInput = class NodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.inputRawData = false;
    }
    // Utiliser un observateur pour surveiller les changements de la propriété `input`
    willUpdate(changedProperties) {
        if (changedProperties.has('input') && this.input?.value) {
            const value = this.input.value;
            this.inputRawData = typeof value === 'string' && (value.includes('{{') || value.includes('}}'));
        }
    }
    render() {
        const nativelyRawInput = ['text-node-input', 'text-area-node-input', 'python-code-node-input'].includes(this.input?.webcomponent || '');
        return litHtml `
      <div class="node-input">
        <div class="node-input__label">
          ${this.input?.name || msg('No label provided', { id: 'nodeInput.noLabel', desc: 'No label provided message' })}
        </div>
        <div class="node-input__helper">
          <span>${this.input?.helper || msg('No description available', { id: 'nodeInput.noDescription', desc: 'No description available message' })}</span>
        </div>
        <div class="node-input__webcomponent-container">
          <div class="node-input__webcomponent">
            ${(!this.inputRawData || nativelyRawInput)
            ? html `
                  <${unsafeStatic(this.input?.webcomponent || 'div')}
                    .key=${this.key}
                    .input=${this.input}
                    .apiService=${this.apiService}
                  ></${unsafeStatic(this.input?.webcomponent || 'div')}>`
            :
                html `
                <text-area-node-input
                  .key=${this.key}
                  .input=${this.input}
                  .apiService=${this.apiService}
                ></text-area-node-input>`}
          </div>
          ${!nativelyRawInput
            ? litHtml `
              <label class="node-input__checkbox">
                <input
                  type="checkbox"
                  .checked=${this.inputRawData}
                  @change=${(e) => this.inputRawData = e.target.checked}>
                ${msg('Raw data', { id: 'nodeInput.rawData', desc: 'Raw data checkbox label' })}
              </label>`
            : ''}
        </div>
        <div class="node-input__preview">
          ${msg('Preview:', { id: 'nodeInput.preview', desc: 'Preview label' })} ${'TODO: implement preview rendering'}
        </div>
      </div>
    `;
    }
};
NodeInput.styles = css `
    .node-input {
      display: flex;
      flex-direction: column;
      gap: 3px;
      font-family: inherit;
      margin-top: 6px;
      width: 100%;
    }
    .node-input__label {
      font-weight: bold;
      margin-bottom: 1.5px;
    }
    .node-input__helper {
      font-size: 0.6375rem;
      color: #666;
    }
    .node-input__webcomponent-container {
      display: flex;
      align-items: center;
      margin-top: 3px;
      width: 100%;
    }
    .node-input__webcomponent {
      flex-grow: 1;
    }
    .node-input__checkbox {
      margin-left: 6px;
      font-size: 0.6rem;
      display: flex;
      align-items: center;
    }
    .node-input__checkbox input {
      margin-right: 3px;
    }
    .node-input__preview {
      margin-top: 3px;
      font-size: 0.525rem;
      font-family: inherit;
      color: #1b6dcaff;
    }
  `;
__decorate([
    property({ type: String })
], NodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], NodeInput.prototype, "input", void 0);
__decorate([
    property({ type: Object })
], NodeInput.prototype, "apiService", void 0);
__decorate([
    state()
], NodeInput.prototype, "inputRawData", void 0);
NodeInput = __decorate([
    localized(),
    customElement('node-input')
], NodeInput);
export { NodeInput };
//# sourceMappingURL=NodeInput.js.map